<template>
  <el-dialog :title="title" :append-to-body="true" :visible.sync="showTag" width="30%">
    <el-form :model="form" :rules="rules" label-width="100px" size="mini" ref="form">
      <el-form-item label="转诊时间" prop="referralTime">
        <el-date-picker type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                        v-model="form.referralTime" :picker-options="{disabledDate}"></el-date-picker>
      </el-form-item>
      <el-form-item label="主管医生" prop="directorDoc">
        <el-input v-model="form.directorDoc"></el-input>
      </el-form-item>
      <el-form-item label="联系方式" prop="directorDocMobile">
        <el-input v-model="form.directorDocMobile"></el-input>
      </el-form-item>
      <el-form-item label="转运方式">
        <el-select v-model="form.dispatchingCarType" filterable placeholder="请选择">
          <el-option v-for="(item,index) in types" :key="index" :label="item.name"
                     :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="救护车" v-if="showJhcItem" prop="emergencyAmbulanceId">
        <el-select v-model="form.emergencyAmbulanceId" filterable placeholder="请选择">
          <el-option v-for="(item,index) in carList" :key="index" :label="item.ambulanceName"
                     :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="司机" v-if="showJhcItem" prop="aid_driver">
        <el-select v-model="form.aid_driver" filterable placeholder="请选择">
          <el-option v-for="(item,index) in driverList" :key="index" :label="item.staffName"
                     :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="急救医生" v-if="showJhcItem" prop="doc">
        <el-select v-model="form.doc" filterable placeholder="请选择">
          <el-option v-for="(item,index) in docList" :key="index" :label="item.docName"
                     :value="item.emergencyPersonnelId"></el-option>
        </el-select>
      </el-form-item>
      <template v-if="showJhcItem">
        <el-form-item :label="index===0?'急救护士':''" v-for="(data,index) in form.nurse" :key="index">
          <el-select v-model="form.nurse[index]" filterable placeholder="请选择">
            <el-option v-for="(item,index) in nurseList" :key="index" :label="item.docName"
                       :value="item.emergencyPersonnelId" :disabled="item.disabled"></el-option>
          </el-select>
          <span class="color_red ml5 pointer" @click.prevent="remove(index)" v-if="index>0">删除</span>
        </el-form-item>
      </template>
      <el-form-item label="" v-if="showJhcItem">
        <el-button type="text" @click="add" size="mini">+增加</el-button>
      </el-form-item>
      <el-form-item label="转运注意事项">
        <el-input type="textarea" v-model="form.transportCarefulMatter"></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input type="textarea" v-model="form.remark"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="mini" @click="reset">重置</el-button>
      <el-button type="primary" @click="sub" size="mini">确认安排</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {systemService} from "../../../common/lib/service/system";
import {staffService} from "../service/staff";
import {USER_TYPE} from "../../../common/lib/config";
import dayjs from 'dayjs'
import {isEmpty} from "../../../common/lib/utils";
import {HOPEDISPATCHINGCARTYPE} from "../config";
import {STAFF_PROCESS_ORDER_SUCCESS} from "../events";
import {timeFilter} from "../../../common/lib/filters";
import {disabledDate} from "../filter";
import fa from "element-ui/src/locale/lang/fa";

const FIELDS = ['dispatchingCarType', 'referralTime', 'aid_driver', 'doc', 'nurse', 'remark', 'emergencyAmbulanceId'];
export default {
  name: "arrange-dialog",
  props: {
    aspectUser: String
  },
  data() {
    let form = {};
    FIELDS.forEach(r => {
      form[r] = '';
    });
    return {
      showTag: false,
      info: {},
      form: {
        ...form,
        nurse: ['']
      },
      rules: {
        referralTime: [
          {required: true, message: '请选择转诊时间', trigger: 'blur'}
        ],
        directorDoc: [
          {required: true, message: '请填写主管医生', trigger: 'blur'}
        ],
        directorDocMobile: [
          {required: true, message: '请填写联系方式', trigger: 'blur'}
        ],
        /*emergencyAmbulanceId: [
          {required: true, message: '请选择救护车', trigger: 'blur'}
        ],
        aid_driver: [
          {required: true, message: '请选择司机', trigger: 'blur'}
        ],
        doc: [
          {required: true, message: '请选择医生', trigger: 'blur'}
        ]*/
      },
      docList: [],
      nurseList: [],
      driverList: [],
      carList: [],
    }
  },
  computed: {
    types() {
      const list = [...HOPEDISPATCHINGCARTYPE];
      const {hopeHosName, initHosName} = this.info;
      return list.map(r => {
        let name = r.name;
        name = name.replace("上级医院", hopeHosName || "对方医院");
        name = name.replace("下级医院", initHosName || "本院");
        return {...r, name};
      });
    },
    showJhcItem() {
      const {aspectUser, form} = this;
      if (aspectUser === 'accept' && ['SUB_HOSPITAL_AMBULANCE', 'THIRD_PARTY_AMBULANCE'].includes(form.dispatchingCarType)) return false;
      return true;
    },
    title() {
      return this.info && this.info.action === 'perfect' ? '修改转诊' : '安排转诊';
    },
    showNurseList() {
      return this.nurseList.map(r => {
        if (this.form.nurse.includes(r.emergencyPersonnelId)) {
          r.disabled = true;
        } else {
          r.disabled = false;
        }
        return r;
      });
    }
  },
  methods: {
    disabledDate,
    show(data) {
      this.info = data;
      this.setForm();
      this.getDriver();
      this.getDoc();
      this.getNurse();
      this.getCar();
      this.getHos();
      this.showTag = true;
    },
    hide() {
      this.showTag = false;
    },
    add() {
      this.form.nurse.push('');
    },
    setForm() {
      const {info} = this;
      if (!isEmpty(info)) {
        info.referralTime && this.$set(this.form, 'referralTime', timeFilter(info.referralTime, 'YYYY-MM-DD'));
        info.hopeDispatchingCarType && this.$set(this.form, 'dispatchingCarType', info.hopeDispatchingCarType);
        ['remark'].forEach(r => {
          info[r] && this.$set(this.form, r, info[r]);
        });
      }
    },
    reset() {
      FIELDS.forEach(r => {
        r !== 'nurse' && this.$set(this.form, r, '');
      });
      this.$set(this.form, 'nurse', ['']);
    },
    remove(index) {
      this.form.nurse.splice(index, 1)
    },
    async getHos() {
      this.hosList = await systemService.listHos(this.loginInfo.hosId);
    },
    async getCar() {
      this.carList = await staffService.listCarNoPage();
    },
    async getDriver() {
      this.driverList = await staffService.listDriverNoPage();
    },
    async getDoc() {
      this.docList = await staffService.listDocNoPage(USER_TYPE.DOC.id);
    },
    async getNurse() {
      this.nurseList = await staffService.listDocNoPage(USER_TYPE.NURSE.id);
    },

    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(valid => {
          if (valid) resolve(true);
          else reject(false)
        })
      })
    },

    async sub() {

      const valid = await this.validate().catch(() => false);
      if (!valid) return;

      const form = {...this.form};
      form.staffingList = [];
      ['aid_driver', 'doc'].forEach(r => {
        if (form[r]) {
          form.staffingList.push({
            emergencyPersonnelId: form[r],
            emergencyPersonnelType: r.toUpperCase()
          });
          delete form[r];
        }
      });
      if (form.nurse && form.nurse.length && form.nurse.some(r => !isEmpty(r))) {
        form.nurse.forEach(r => {
          r && form.staffingList.push({
            emergencyPersonnelId: r,
            emergencyPersonnelType: 'nurse'.toUpperCase()
          })
        });
        delete form.nurse;
      }
      if (form.staffingList.length === 0) delete form.staffingList;
      if (form.referralTime) form.referralTime = dayjs(form.referralTime).valueOf();

      // 非本院派车
      if (!this.showJhcItem) {
        delete form.staffingList;
        delete form.emergencyAmbulanceId
      }

      if (await staffService.processOrder({
        orderId: this.info.id,
        ...form
      })) {
        this.hide();
        this.$message.success({
          message: '操作成功',
          onClose: () => {
            bus.$emit(STAFF_PROCESS_ORDER_SUCCESS.id, 0);
          }
        })
      } else {
        this.hide();
        bus.$emit(STAFF_PROCESS_ORDER_SUCCESS.id, 0);
      }
    }
  },
}
</script>

<style scoped>
</style>
